import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-telephone",
  "use": "icon-telephone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-telephone\"><defs><style type=\"text/css\"></style></defs><path d=\"M782.336 713.728V137.216c0-21.504-17.408-39.424-39.424-39.424H281.088c-21.504 0-39.424 17.408-39.424 39.424v576.512h540.672z m-540.672 33.28v139.264c0 25.088 19.968 45.056 45.056 45.056h433.664c44.032 0 60.928-18.944 60.928-66.56V747.52H241.664z m270.336 98.304c-16.384 0-29.184-12.8-29.184-29.184 0-15.36 13.312-28.672 28.672-28.672 16.384 0 29.184 12.8 29.184 29.184 0.512 15.36-12.288 28.672-28.672 28.672z\" p-id=\"24997\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/telephone.svg
// module id = T5Ms
// module chunks = 7